import { lazy } from "react";

// Icons import
import { FaHome } from "react-icons/fa";
import { CiMoneyBill } from "react-icons/ci";
import { MdCurrencyExchange } from "react-icons/md";
import { MdAddShoppingCart } from "react-icons/md";
import { CiShop } from "react-icons/ci";
import { FaProductHunt } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import StorageIcon from "@mui/icons-material/Storage";
// import EditIcon from "@mui/icons-material/Edit"; // Хэрэглэхээ болисон
import InsightsIcon from "@mui/icons-material/Insights";

// Lazy loading ашиглан хуудаснуудыг import хийх - Code splitting
const HomePage = lazy(() => import("../../pages/HomePage"), {
  webpackChunkName: "home-page",
});
const MoneyConverterPage = lazy(
  () => import("../../pages/MoneyConverterPage"),
  {
    webpackChunkName: "money-converter",
  }
);
const MoneyTrackerPage = lazy(() => import("../../pages/MoneyTrackerPage"), {
  webpackChunkName: "money-tracker",
});
const FacebookPages = lazy(() => import("../../pages/FacebookPages"), {
  webpackChunkName: "facebook-pages",
});
const ProductManagement = lazy(() => import("../../pages/ProductManagement"), {
  webpackChunkName: "product-management",
});
const PurchaseProducts = lazy(() => import("../../pages/PurchaseProducts"), {
  webpackChunkName: "purchase-products",
});
// FacebookSpend, FacebookAdsByDay хуудсуудыг хуучин маршрут дээр
// шинэ `FacebookAdsAdmin` руу чиглүүлж байгаа тул тусдаа lazy import хэрэггүй
const FacebookAdsAdmin = lazy(() => import("../../pages/FacebookAdsAdmin"), {
  webpackChunkName: "facebook-ads-admin",
});
const SalesReport = lazy(() => import("../../pages/SalesReport"), {
  webpackChunkName: "sales-report",
});
const AdminUsers = lazy(() => import("../../pages/AdminUsers"), {
  webpackChunkName: "admin-users",
});
// Хуучин тус тусад байсан original хуудсуудыг нэг табтай хуудсанд нэгтгэсэн тул эдгээр lazy import-ууд одоо ашиглагдахгүй
const OriginalDataTabs = lazy(() => import("../../pages/OriginalData"), {
  webpackChunkName: "original-data-tabs",
});
const OriginalDataInspector = lazy(
  () => import("../../pages/OriginalDataInspector"),
  { webpackChunkName: "original-data-inspector" }
);
const DeliveryEditData = lazy(() => import("../../pages/DeliveryEditData"), {
  webpackChunkName: "delivery-edit",
});
const BotRunStats = lazy(() => import("../../pages/BotRunStats"), {
  webpackChunkName: "bot-run-stats",
});
const ResearchStarter = lazy(() => import("../../pages/ResearchStarter"), {
  webpackChunkName: "research-starter",
});

export const nav = [
  {
    path: "/home",
    name: "Home",
    element: <HomePage />,
    isMenu: false,
    isPrivate: false,
    icon: <FaHome />,
  },
  
  // БАРАА цэс - үндсэн цэс
  {
    path: "/products",
    name: "Бараа",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "products",
    icon: <FaProductHunt />,
    group: "main",
    menuOrder: 1,
    isParent: true,
  },
  {
    path: "/products/management",
    name: "Барааны удирдлага",
    element: <ProductManagement />,
    isMenu: true,
    isPrivate: true,
    code: "product-management",
    icon: <FaProductHunt />,
    group: "main",
    parent: "products",
    menuOrder: 1,
  },
  {
    path: "/products/purchase",
    name: "Худалдан авалт",
    element: <PurchaseProducts />,
    isMenu: true,
    isPrivate: true,
    code: "purchase-products",
    icon: <MdAddShoppingCart />,
    group: "main",
    parent: "products",
    menuOrder: 2,
  },

  // ХҮРГЭЛТ цэс - үндсэн цэс
  {
    path: "/delivery",
    name: "Хүргэлт",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "delivery",
    icon: <MdDeliveryDining />,
    group: "main",
    menuOrder: 2,
    isParent: true,
  },
  {
    path: "/delivery/original",
    name: "Эх өгөгдөл",
    element: <OriginalDataTabs />,
    isMenu: true,
    isPrivate: true,
    code: "delivery-original",
    icon: <StorageIcon />,
    group: "main",
    parent: "delivery",
    menuOrder: 1,
  },
  {
    path: "/delivery/processed",
    name: "Боловсруулсан өгөгдөл",
    element: <DeliveryEditData />,
    isMenu: true,
    isPrivate: true,
    code: "delivery-processed",
    icon: <MdDeliveryDining />,
    group: "main",
    parent: "delivery",
    menuOrder: 2,
  },

  // МАРКЕТИНГ цэс - үндсэн цэс
  {
    path: "/marketing",
    name: "Маркетинг",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "marketing",
    icon: <CiShop />,
    group: "main",
    menuOrder: 3,
    isParent: true,
  },
  {
    path: "/marketing/facebook-pages",
    name: "Facebook хуудсууд",
    element: <FacebookPages />,
    isMenu: true,
    isPrivate: true,
    code: "facebook-pages",
    icon: <CiShop />,
    group: "main",
    parent: "marketing",
    menuOrder: 1,
  },
  {
    path: "/marketing/facebook-ads",
    name: "FB Ads удирдлага",
    element: <FacebookAdsAdmin />,
    isMenu: true,
    isPrivate: true,
    code: "facebook-ads-admin",
    icon: <MonetizationOnIcon />,
    group: "main",
    parent: "marketing",
    menuOrder: 2,
  },

  // ШИНЖИЛГЭЭ цэс - үндсэн цэс
  {
    path: "/analytics",
    name: "Шинжилгээ",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "analytics",
    icon: <AssessmentIcon />,
    group: "main",
    menuOrder: 4,
    isParent: true,
  },
  {
    path: "/analytics/sales-report",
    name: "Борлуулалтын тайлан",
    element: <SalesReport />,
    isMenu: true,
    isPrivate: true,
    code: "sales-report",
    icon: <AssessmentIcon />,
    group: "main",
    parent: "analytics",
    menuOrder: 1,
  },
  {
    path: "/analytics/bot-stats",
    name: "Bot Run Stats",
    element: <BotRunStats />,
    isMenu: true,
    isPrivate: true,
    code: "bot-run-stats",
    icon: <InsightsIcon />,
    group: "main",
    parent: "analytics",
    menuOrder: 2,
  },
  {
    path: "/analytics/research-starter",
    name: "Судалгаа эхлүүлэх",
    element: <ResearchStarter />,
    isMenu: true,
    isPrivate: true,
    code: "research-starter",
    icon: <InsightsIcon />,
    group: "main",
    parent: "analytics",
    menuOrder: 3,
  },

  // САНХҮҮ цэс - үндсэн цэс
  {
    path: "/finance",
    name: "Санхүү",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "finance",
    icon: <CiMoneyBill />,
    group: "main",
    menuOrder: 5,
    isParent: true,
  },
  {
    path: "/finance/money-tracker",
    name: "Money Tracker",
    element: <MoneyTrackerPage />,
    isMenu: true,
    isPrivate: true,
    code: "money-tracker",
    icon: <CiMoneyBill />,
    group: "main",
    parent: "finance",
    menuOrder: 1,
  },
  {
    path: "/finance/money-converter",
    name: "Валютын хөрвүүлэгч",
    element: <MoneyConverterPage />,
    isMenu: true,
    isPrivate: true,
    code: "money-converter",
    icon: <MdCurrencyExchange />,
    group: "main",
    parent: "finance",
    menuOrder: 2,
  },

  // СИСТЕМ цэс - үндсэн цэс
  {
    path: "/system",
    name: "Систем",
    element: null, // Энэ нь зөвхөн цэс, хуудас биш
    isMenu: true,
    isPrivate: true,
    code: "system",
    icon: <PeopleAltIcon />,
    group: "main",
    menuOrder: 6,
    isParent: true,
  },
  {
    path: "/system/admin-users",
    name: "Хэрэглэгчийн удирдлага",
    element: <AdminUsers />,
    isMenu: true,
    isPrivate: true,
    code: "admin-users",
    icon: <PeopleAltIcon />,
    group: "main",
    parent: "system",
    menuOrder: 1,
  },

  // Хуучин маршрутууд - менюгээс нуух
  {
    path: "/original-inspector",
    name: "Original Inspector",
    element: <OriginalDataInspector />,
    isMenu: false,
    isPrivate: true,
    code: "original-inspector",
    icon: <StorageIcon />,
  },
  {
    path: "/facebook-spend",
    name: "Facebook Зарцуулалт",
    element: <FacebookAdsAdmin />,
    isMenu: false,
    isPrivate: true,
    code: "facebook-spend",
    icon: <MonetizationOnIcon />,
  },
  {
    path: "/facebook-ads-by-day",
    name: "Facebook Зардал (өдрөөр)",
    element: <FacebookAdsAdmin />,
    isMenu: false,
    isPrivate: true,
    code: "facebook-ads-by-day",
    icon: <MonetizationOnIcon />,
  },
];
